import { ChatMode } from "../model/types";
import { useChatController } from "../model/useChatController";
import { ChatComposer } from "./ChatComposer";
import { ChatMessageList } from "./ChatMessageList";
import css from "./ChatPanel.module.scss";

interface ChatPanelProps {
  className?: string;
}

/**
 * Тело чата: лента сообщений + композер.
 *
 * Заголовок и закрытие живут снаружи — переключателем над табами
 * (`RoundsDetails`), поэтому панель не дублирует свою шапку.
 */
export function ChatPanel({ className = "" }: ChatPanelProps) {
  const chat = useChatController();

  // Fail closed: любой режим кроме viewer-aware полностью скрывает чат.
  if (chat.mode !== ChatMode.CHAT_MODE_VIEWER_AWARE) return null;

  return (
    <section className={`${css.panel} ${className}`}>
      <ChatMessageList chat={chat} />

      <ChatComposer disabled={!chat.connected} onSend={chat.send} />
    </section>
  );
}
